import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './output.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/browser";  

Sentry.init({
  dsn: process.env.REACT_APP_GLITCHTIP_DSN,
  environment: process.env.REACT_APP_ENV,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <App />
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
